import React, { MouseEvent, useState, Dispatch, useEffect, useCallback, useRef } from 'react';
import { DebouncedFunc } from 'lodash';

import '../App.css';
import { ItemTypes } from '../ItemTypes'
import Vote from './Vote'
import RFIVote from './RFIVote'
import TTLDots from './TTLDots'
import { useDrop } from 'react-dnd'
import { IInject, IInjectNode, ICOA, IRFI, IRoleContent, IScenario } from '../interfaces';
import { COA, RFI, RoleContent, TimeToLive } from '../Classes1';
import ContentEditable from 'react-contenteditable'
import useResizeObserver from './useResizeObserver';
import { mergeRefs } from '../helpers/helperFunctions';

interface NodeProps {
    id: string;
    index: number;
    injectComponents: IInject[];
    turn: number;
    greedy: boolean;
    setInjectComponents: Dispatch<any>;
    setInjectItem: Dispatch<any>;
    injectItem: IInject;
    zoomLevel: number;
    selectedScenario: IScenario;
    node: IInjectNode;
    setIsCOADragging: Dispatch<boolean>;
    isCOADragging: boolean;
    coaClicked: boolean;
    setCoaClicked: Dispatch<boolean>;
    onChangeSave: DebouncedFunc<any>;
    saveScenario: (i: IInject[]) => Promise<void>;
    setNodeTurnHeight: Dispatch<string>;
    setNodeTurnHeightArray: Dispatch<any>;
    nodeTurnHeightArray: any;
    onFocus: () => void;
    onBlur: () => void;
}

  export interface Item {
    id: number
    text: string
  }

  export interface coaArr {
    id: number
    text: string
  }

  export interface IDropItem {
    name: string
  }

  export interface INodeTurnHeight {
    nodeId: string;
    turn: number;
    height: number;
  }

  export class NodeTurnHeight {
    nodeId: string = '';
    turn: number = 0;
    height: number = 0;
  }

const Node: React.FC<NodeProps> = ({
    id, node, injectComponents, turn, injectItem, selectedScenario,
    greedy, index, zoomLevel, isCOADragging, coaClicked, nodeTurnHeightArray,
    onChangeSave, saveScenario, setInjectItem, setInjectComponents,
    setNodeTurnHeight, setIsCOADragging, setNodeTurnHeightArray, setCoaClicked, onFocus, onBlur,
}) => {

    let [isCOAEditing, setIsCOAEditing] = useState<string>('');
    let [hasCoa, setHasCoa] = useState<string>('');
    let [showCoaEditBtns, setShowCoaEditBtns] = useState<string>('hide');
    let [isRFIEditing, setIsRFIEditing] = useState<string>('');
    let [hasRFI, setHasRFI] = useState<string>('');
    let [showRFIEditBtns, setShowRFIEditBtns] = useState<string>('hide');
    let [isInfoEditing, setIsInfoEditing] = useState<string>('');
    let [hasInfo, setHasInfo] = useState<string>('');
    let [hasTTL, setHasTTL] = useState<string>('');
    let [showInfoEditBtns, setShowInfoEditBtns] = useState<string>('hide');
    let [descOpen, setDescOpen] = useState<string>('open');
    let [rotateDescChevron, setRotateDescChevron] = useState<string>('down');
    let [rotateCOAChevron, setRotateCOAChevron] = useState<string>('down');
    let [rotateRFIChevron, setRotateRFIChevron] = useState<string>('down');
    let [rotateInfoChevron, setRotateInfoChevron] = useState<string>('down');
    // let [selectedOption, setSelectedOption] = useState<ISelectedOption | null>(new SelectedOption({}))
    let [descTop, setDescTop] = useState<string>('0px');
    let [coaTop, setCOATop] = useState<string>('0px');
    let [rfiTop, setRFITop] = useState<string>('0px');
    let [infoTop, setInfoTop] = useState<string>('0px');

    let [descHeight, setDescHeight] = useState<number>(40);
    let [coaHeight, setCOAHeight] = useState<number>(0);
    let [rfiHeight, setRFIHeight] = useState<number>(40);
    let [infoHeight, setInfoHeight] = useState<number>(40);

    let [coaOpen, setCOAOpen] = useState<string>('open');
    let [rfiOpen, setRFIOpen] = useState<string>('open');
    let [infoOpen, setInfoOpen] = useState<string>('open');
    let [ttlMarginTop, setTTLMarginTop] = useState<string>('');
    let [showNodeMenu, setShowNodeMenu] = useState<string>('hide');
    const [isConnected, setIsConnected] = useState<boolean>(true)
    const [nodeHeight, setNodeHeight] = useState<string>('0')
    const [nodeDiv, setNodeDiv] = useState<HTMLElement>()

    let rfiCloseHeight: number = 60;
    let infoCloseHeight: number = 60;
    const coaDivsRef = useRef<HTMLElement[]>([])
    const rfiQuestionsDivsRef = useRef<HTMLElement[]>([])
    const rfiAnswersDivsRef = useRef<HTMLElement[]>([])
    const infoBriefsDivsRef = useRef<HTMLElement[]>([])

    const getNodeHeight = (newNodeTurnHeightArray: INodeTurnHeight[]) => {
        let nodeHeights: any[] = [];
        for (let i = 0; i<newNodeTurnHeightArray.length; i++) {
            if (nodeHeights.filter((item: any) => item.turn === newNodeTurnHeightArray[i].turn).length > 0) {
                // item exists
                nodeHeights.filter((item: any) => item.turn === newNodeTurnHeightArray[i].turn)[0].height += newNodeTurnHeightArray[i].height;
            } else {
                let nodeHeight: any = {}
                nodeHeight.height = newNodeTurnHeightArray[i].height
                nodeHeight.turn = newNodeTurnHeightArray[i].turn
                nodeHeights.push(nodeHeight)
            }
        }

        let heightNumbers: number[] = []
        nodeHeights.forEach((item) => {
            heightNumbers.push(item.height)
        })
        const maxHeight = Math.max(...heightNumbers);
        
        setNodeTurnHeight((maxHeight + 80) + 'px')
    }

    const ref = useResizeObserver((rect: any) => {

        let newNodeTurnHeightArray: INodeTurnHeight[] = JSON.parse(JSON.stringify(nodeTurnHeightArray))
        let hasItem: INodeTurnHeight[] = nodeTurnHeightArray.filter((item: INodeTurnHeight) => item.nodeId === id)
        let newItem: INodeTurnHeight = new NodeTurnHeight();
        
        newItem.height = rect.height
        newItem.turn = turn;
        newItem.nodeId = id;
        
        if (hasItem.length > 0) {
            let hasChanged: boolean = false;
            
            nodeTurnHeightArray.forEach((item: INodeTurnHeight) => {
                if (item.nodeId === id) {
                    if (rect.height !== item.height) {
                        hasChanged = true;
                    }
                }
            })

            if (hasChanged) {
                newNodeTurnHeightArray = newNodeTurnHeightArray.map((item: INodeTurnHeight) => {
                    if (item.nodeId === id) {
                        if (rect.height !== item.height) {
                            return newItem
                        } else {
                            return item;
                        }
                    } else {
                        return item;
                    }
                })
                getNodeHeight(newNodeTurnHeightArray)
                setNodeTurnHeightArray(newNodeTurnHeightArray);
            }
        } else {
            newNodeTurnHeightArray.push(newItem);
            getNodeHeight(newNodeTurnHeightArray)
            setNodeTurnHeightArray(newNodeTurnHeightArray)
        }
    });

    useEffect(() => {
        const nodediv: HTMLElement = document.querySelector('.node[data-id="'+ id +'"]') as HTMLElement
        setNodeDiv(nodediv)
    }, [id])
    
    useEffect(() => {
        injectItem.nodes.forEach((node: IInjectNode) => {
            if (node.id === id) {
                const coaDivs = document.querySelectorAll('.coa-vote-desc[data-nodeid="'+ id +'"]')
                if (coaDivs !== null) {
                    coaDivsRef.current = Array.from(coaDivs) as HTMLElement[]
                }

                const rfiQuestionsDivs = document.querySelectorAll('.rfi-vote-question[data-nodeid="'+ id +'"]')
                if (rfiQuestionsDivs !== null) {
                    rfiQuestionsDivsRef.current = Array.from(rfiQuestionsDivs) as HTMLElement[]
                }

                const rfiAnswersDivs = document.querySelectorAll('.rfi-vote-desc[data-nodeid="'+ id +'"]')
                if (rfiAnswersDivs !== null) {
                    rfiAnswersDivsRef.current = Array.from(rfiAnswersDivs) as HTMLElement[]
                }

                const infoBriefsDivs = document.querySelectorAll('.info-vote-desc[data-nodeid="'+ id +'"]')
                if (infoBriefsDivs !== null) {
                    infoBriefsDivsRef.current = Array.from(infoBriefsDivs) as HTMLElement[]
                }
            }
        });
        
    }, [injectItem.nodes]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        
        injectItem.nodes.forEach((node: IInjectNode) => {
            if (node.id === id.toString()) {
                setDescHeight(contentEditableRef.current.el.current.offsetHeight)

                if (node.descHeight !== contentEditableRef.current.el.current.offsetHeight) {
                    let newNodes1: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
            
                    newNodes1.forEach((item) => {
                        if (id.toString() === item.id) {
                            item.descOpen = true;
                            item.descHeight = contentEditableRef.current.el.current.offsetHeight;
                        }
                    })

                    setInjectItem({
                        ...injectItem,
                        nodes: newNodes1
                    });
                    setInjectComponents(injectComponents.map((inject: IInject) => {
                        if (inject.id === injectItem.id) {
                            return { ...inject, nodes: newNodes1 };
                        } else {
                            return inject;
                        }
                    }));
                }

                if (node.coas.length > 0) {
                    setHasCoa('coa')
                    let coaHeight: number = 38;
                   if (node.coaOpen) {
                        coaDivsRef.current.forEach((coa: HTMLElement, i: number) => {
                            coaHeight += coa.offsetHeight + 6
                        })
                        coaHeight += 22
                    }
                    if (node.coaEditOpen && node.coaOpen) {
                        coaHeight += 54
                    }
                    if (!node.coaEditOpen && node.coaOpen) {
                        coaHeight += 0;
                    }
                    
                    setCOAHeight(coaHeight)
                } else {
                    setHasCoa('')
                }

                if (node.rfis.length > 0) {
                    let rfiHeight: number = 38;

                    if (node.rfiOpen) {
                        rfiQuestionsDivsRef.current.forEach((rfiq: any, i: number) => {
                            rfiHeight += rfiq.offsetHeight + 6
                        })
                        rfiAnswersDivsRef.current.forEach((rfia: any, i: number) => {
                            rfiHeight += rfia.offsetHeight + 6
                        })
                        rfiHeight += 52
                    }
                    if (node.rfiEditOpen && node.rfiOpen) {
                        rfiHeight += 54
                    }
                    setRFIHeight(rfiHeight)
                    setHasRFI('rfi')
                } else {
                    setHasRFI('')
                }
                if (node.informationBriefs.length > 0) {
                    let infoHeight: number = 38;
                    if (node.infoOpen) {
                        infoBriefsDivsRef.current.forEach((info: HTMLElement, i: number) => {
                            infoHeight += info.offsetHeight + 20
                        })
                        infoHeight += 5;
                    }
                    setInfoHeight(infoHeight)
                    setHasInfo('info')
                } else {
                    setHasInfo('')
                }
                if (node.timeToLive !== null) {
                    setHasTTL('ttl')
                } else {
                    setHasTTL('')
                }
            }
        });
        calcInjectHeight()
    })

    useEffect(() => {
        let coaIsConnected: boolean = false;
       
        injectItem.nodes.forEach((node1: IInjectNode) => {
            node1.coas.forEach((coa: ICOA) => {
                if (coa.nextNodeId === id.toString()) {
                    coaIsConnected = true
                }
            })
            if (node1.timeToLive !== null) {
                if (node1.timeToLive.nextNodeId === id.toString()) {
                    coaIsConnected = true
                }
            }
        })
        setIsConnected(coaIsConnected)

    }, [injectItem.nodes]) // eslint-disable-line react-hooks/exhaustive-deps

    const injectComponentsRef = useRef<IInject[]>([])
    useEffect(() => {
        injectComponentsRef.current = injectComponents;
    });

    /*
    const CustomDropdownIndicator = (props: any) => {
        return (
          <components.DropdownIndicator {...props}>
            <img src="img/chevron-down-grey.svg" className={`chevron-down-grey`} alt="arrow" />
          </components.DropdownIndicator>
        );
    };
    */

    const addCOAOption = (ev: MouseEvent) => {
        ev.stopPropagation();
        let newNodes: IInjectNode[] = [];

        newNodes = JSON.parse(JSON.stringify(injectItem.nodes));
        newNodes.forEach((item) => {
            if (id.toString() === item.id) {
                let newCoa: ICOA = new COA({});
                newCoa.displayText = ''
                newCoa.nextNodeId = ''

                let coaIds: number[] = [];
                injectItem.nodes.forEach((node: IInjectNode) => {
                    node.coas.forEach((coa: ICOA) => {
                        coaIds.push(coa.id)
                    })
                })

                newCoa.id = (Math.max(...coaIds) + 1)
                newCoa.isNew = true;
                item.coas.push(newCoa)
            }
        })

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, nodes: newNodes };
            } else {
                return inject;
            }
          }));
    }

    const addRFIOption = (ev: MouseEvent) => {
        ev.stopPropagation();
        let newNodes: IInjectNode[] = [];
        
        newNodes = JSON.parse(JSON.stringify(injectItem.nodes));
        newNodes.forEach((item) => {
            if (id.toString() === item.id) {
                let newRFI: IRFI = new RFI();
                newRFI.displayText = ''
                newRFI.nextNodeId = ''
                newRFI.id = item.rfis.length + 1;
                newRFI.isNew = true;
                let rc = new RoleContent();
                rc.role = "All";
                rc.displayText = ""
                newRFI.roleContent = [rc];
                item.rfis.push(newRFI)
            }
        })

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, nodes: newNodes };
            } else {
                return inject;
            }
          }));
    }

    const addInfoOption = (ev: MouseEvent) => {
        ev.stopPropagation();
        let newNodes: IInjectNode[] = [];
        
        newNodes = JSON.parse(JSON.stringify(injectItem.nodes));
        newNodes.forEach((item) => {
            if (id.toString() === item.id) {
                let newInfo: IRoleContent = new RoleContent();
                newInfo.displayText = ''
                newInfo.role = '';
                item.informationBriefs.push(newInfo)
            }
        })

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, nodes: newNodes };
            } else {
                return inject;
            }
          }));
    }

    const editCoa = (ev: MouseEvent) => {
        ev.stopPropagation();

        if (isCOAEditing === 'coa') {
            setIsCOAEditing('')
            setShowCoaEditBtns('hide')
            let newNodes1: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes1.forEach((item) => {
                if (id.toString() === item.id) {
                    item.coaEditOpen = false;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes1
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes1 };
                } else {
                    return inject;
                }
              }));
        } else {
            setIsCOAEditing('coa')
            setShowCoaEditBtns('')
            let newNodes1: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes1.forEach((item) => {
                if (id.toString() === item.id) {
                    item.coaEditOpen = true;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes1
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes1 };
                } else {
                    return inject;
                }
              }));
        }
    }

    const editRFI = (ev: MouseEvent) => {
        ev.stopPropagation();
        if (isRFIEditing === 'rfi') {
            setIsRFIEditing('')
            setShowRFIEditBtns('hide')
            let newNodes1: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes1.forEach((item) => {
                if (id.toString() === item.id) {
                    item.rfiEditOpen = false;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes1
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes1 };
                } else {
                    return inject;
                }
              }));
        } else {
            setIsRFIEditing('rfi')
            setShowRFIEditBtns('')
            let newNodes2: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes2.forEach((item) => {
                if (id.toString() === item.id) {
                    item.rfiEditOpen = true;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes2
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes2 };
                } else {
                    return inject;
                }
              }));
        }
    }

    const editInfoDone = (ev: MouseEvent) => {
        setShowInfoEditBtns('hide')
        setIsInfoEditing('')
    }

    const deleteNode = (ev: MouseEvent) => {
        ev.stopPropagation()
        let newNodes = JSON.parse(JSON.stringify(injectItem.nodes.filter((data: IInjectNode, k: number) => data.id !== id.toString() )))

        let tempComponents: IInject[] = JSON.parse(JSON.stringify(injectComponents))
        let turnLength: number = 1;

        for (let k = 0; k<tempComponents.length; k++) {
            if (tempComponents[k].id === injectItem.id) {
              tempComponents[k].nodes = newNodes;
            }
          }

          tempComponents.forEach((inject: IInject) => {
            let hasTurns: number[] = [];
            
            if (inject.id === injectItem.id) {
              for (let i = 0; i<inject.nodes.length; i++) {
                hasTurns.push(inject.nodes[i].turn);
              }
              if (inject.nodes.length < 2) {
                turnLength = 1;
              } else {
                turnLength = Math.max(...hasTurns);
              }
            }
          })

        for (let i = 0; i<tempComponents.length; i++) {
            for (let j = 0; j<tempComponents[i].nodes.length; j++) {
                for (let k = 0; k<tempComponents[i].nodes[j].coas.length; k++) {
                    if (tempComponents[i].nodes[j].coas[k].nextNodeId === id) {
                        tempComponents[i].nodes[j].coas[k].nextNodeId = '';
                    }
                }
                if (tempComponents[i].nodes[j].timeToLive !== null) {
                    if (tempComponents[i].nodes[j].timeToLive!.nextNodeId === id) {
                        tempComponents[i].nodes[j].timeToLive!.nextNodeId = '';
                    }
                }
            }
        }

        tempComponents.forEach((inject: IInject) => {
            if (inject.id === injectItem.id) {
                inject.turnLength = turnLength;
                inject.nodes = newNodes;
            }
        })

        setInjectItem({
            ...injectItem,
            turnLength: turnLength,
            nodes: newNodes
        });

        setInjectComponents(tempComponents)

    }

    const deleteCOA = (ev: MouseEvent) => {
        ev.stopPropagation()
        let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
        newNodes.forEach((item) => {
            if (id.toString() === item.id) {
                item.coas = [];
            }
        })

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, nodes: newNodes };
            } else {
                return inject;
            }
          }));
        setHasCoa('')
    }

    const deleteRFI = (ev: MouseEvent) => {
        ev.stopPropagation()
        let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
        newNodes.forEach((item) => {
            if (id.toString() === item.id) {
                item.rfis = [];
            }
        })

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, nodes: newNodes };
            } else {
                return inject;
            }
          }));
        setHasRFI('')
    }

    const deleteInfo = (ev: MouseEvent) => {
        ev.stopPropagation()
        let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
        newNodes.forEach((item) => {
            if (id.toString() === item.id) {
                item.informationBriefs = [];
            }
        })

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, nodes: newNodes };
            } else {
                return inject;
            }
          }));
        setTTLMarginTop('0')
        setHasInfo('')
    }

    const deleteTTL = (ev: MouseEvent) => {
        ev.stopPropagation()
        let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
        newNodes.forEach((item) => {
            if (id.toString() === item.id) {
                item.timeToLive = null
            }
        })

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, nodes: newNodes };
            } else {
                return inject;
            }
          }));
        setHasTTL('')
    }

    const nameKeyDown = (ev: React.KeyboardEvent<HTMLInputElement>) => {
        if (ev.key === 'Enter') {
            ev.currentTarget.blur()
        }
    }

    const onChangeName = (ev: React.ChangeEvent<HTMLInputElement>) => {
        onChangeSave()
        let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
        newNodes.forEach((item) => {
            if (id.toString() === item.id) {
                item.name = ev.currentTarget.value;
            }
        })

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, nodes: newNodes };
            } else {
                return inject;
            }
        }));
    }

    const clickNodeMenu = (ev: MouseEvent) => {
        showNodeMenu === 'hide' ? setShowNodeMenu('show') : setShowNodeMenu('hide')
    }

    const clickDescOpen = (ev: MouseEvent) => {
        ev.stopPropagation();
        if (descOpen === 'closed') {
            let newNodes1: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes1.forEach((item) => {
                if (id.toString() === item.id) {
                    item.descOpen = true;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes1
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes1 };
                } else {
                    return inject;
                }
              }));
            setRotateDescChevron('down')
            setDescOpen('open');
            setDescTop('0px')
        } else {
            let newNodes2: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes2.forEach((item) => {
                if (id.toString() === item.id) {
                    item.descOpen = false;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes2
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes2 };
                } else {
                    return inject;
                }
              }));
            
            setDescTop('-' + (contentEditableRef.current.el.current.offsetHeight + 16) + 'px')
            setRotateDescChevron('')
            setDescOpen('closed');
        }
        
    }

    const clickCOAOpen = (ev: MouseEvent) => {
        ev.stopPropagation();

        if (coaOpen === 'open') {
            setCOATop('-50px')
            setCOAOpen('closed')
            setShowCoaEditBtns('hide')
            setIsCOAEditing('')
            let newNodes2: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes2.forEach((item) => {
                if (id.toString() === item.id) {
                    item.coaOpen = false;
                    item.coaEditOpen = false;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes2
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes2 };
                } else {
                    return inject;
                }
              }));
            setRotateCOAChevron('')
        } else {
            setCOATop('0')
            let coaHeight: number = 0;
            if (node.coaOpen) {
                coaDivsRef.current.forEach((coa: HTMLElement, i: number) => {
                    coaHeight += coa.offsetHeight + 6
                })
            }
            if (node.coaEditOpen) {
                coaHeight += 58
            }
            setCOAHeight(coaHeight)
            setCOAOpen('open')
    
            let newNodes2: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes2.forEach((item) => {
                if (id.toString() === item.id) {
                    item.coaOpen = true;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes2
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes2 };
                } else {
                    return inject;
                }
            }));
            setRotateCOAChevron('down')
        }
    }

    const clickRFIOpen = (ev: MouseEvent) => {
        ev.stopPropagation();
        rfiCloseHeight = 0;
        
        for (let i = 0; i<injectItem.nodes.length; i++) {
            if (id.toString() === injectItem.nodes[i].id) {
                rfiCloseHeight += (injectItem.nodes[i].rfis.length * 95) + 48;
            }
        }

        if (rfiOpen === 'open') {
            let newNodes2: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes2.forEach((item) => {
                if (id.toString() === item.id) {
                    item.rfiOpen = false;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes2
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes2 };
                } else {
                    return inject;
                }
              }));
            setRFITop('-' + (rfiCloseHeight + 50) + 'px')
            setRFIOpen('closed')
            setShowRFIEditBtns('hide')
            setIsRFIEditing('')
            setRotateRFIChevron('')
        } else {
            let newNodes2: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes2.forEach((item) => {
                if (id.toString() === item.id) {
                    item.rfiOpen = true;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes2
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes2 };
                } else {
                    return inject;
                }
              }));
            setRFITop('0')
            setRFIOpen('open')
            
            let rfiHeight: number = 38;

            if (node.rfiOpen) {
                rfiQuestionsDivsRef.current.forEach((rfiq: HTMLElement, i: number) => {
                    rfiHeight += rfiq.offsetHeight + 6
                })
                rfiAnswersDivsRef.current.forEach((rfia: HTMLElement, i: number) => {
                    rfiHeight += rfia.offsetHeight + 6
                })
            }
            if (node.rfiEditOpen) {
                rfiHeight += 54
            }
            setRFIHeight(rfiHeight)
            setRotateRFIChevron('down')
        }
    }

    const clickInfoOpen = (ev: MouseEvent) => {
        ev.stopPropagation();

        infoCloseHeight = 0;
        
        infoBriefsDivsRef.current.forEach((info: HTMLElement, i: number) => {
            infoCloseHeight += info.offsetHeight + 6
        })

        if (infoOpen === 'open') {
            let newNodes3: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes3.forEach((item) => {
                if (id.toString() === item.id) {
                    item.infoOpen = false;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes3
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes3 };
                } else {
                    return inject;
                }
              }));
            setInfoTop('-' + (infoCloseHeight+56) + 'px')
            setInfoOpen('closed')
            setShowInfoEditBtns('hide')
            setIsInfoEditing('')
            setRotateInfoChevron('')
        } else {
            let newNodes4: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
            newNodes4.forEach((item) => {
                if (id.toString() === item.id) {
                    item.infoOpen = true;
                }
            })

            setInjectItem({
                ...injectItem,
                nodes: newNodes4
            });
            setInjectComponents(injectComponents.map((inject: IInject) => {
                if (inject.id === injectItem.id) {
                    return { ...inject, nodes: newNodes4 };
                } else {
                    return inject;
                }
              }));
            setInfoTop('0')
            setInfoOpen('open')
            setRotateInfoChevron('down')
        }
    }

    const contentEditableRef = useRef<any>(null)

    const onChangeDescText = (ev: React.FormEvent<HTMLInputElement>) => {
        onChangeSave()

        let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
        
        newNodes.forEach((item) => {
            if (id.toString() === item.id) {
                item.description = ev.currentTarget.innerText;
                item.descHeight = contentEditableRef.current.el.current.offsetHeight
            }
        })

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });
        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, nodes: newNodes };
            } else {
                return inject;
            }
          }));
    }

    const calcInjectHeight = () => {
        if (zoomLevel > 1) {
            return 'auto;'
        }

        let injectHeight = 37;

        if (descOpen === 'closed') {
            injectHeight -= 5;
        } else {
            if (contentEditableRef.current !== undefined) {
                injectHeight += contentEditableRef.current.el.current.offsetHeight + 16;
            } else {
                injectHeight += 60
            }
        }

        if (hasCoa === 'coa') {
            if (coaOpen === 'closed') {
                injectHeight += 24;
            } else {
                injectHeight += 44;
                coaDivsRef.current.forEach((coa: HTMLElement, i: number) => {
                    injectHeight += coa.offsetHeight + 6
                })
            }
        } else {
            injectHeight -= 16;
        }

        if (hasRFI === 'rfi') {
            if (rfiOpen === 'closed') {
                injectHeight += 37;
            } else {
                injectHeight += 85;
                rfiQuestionsDivsRef.current.forEach((rfiq: HTMLElement, i: number) => {
                    injectHeight += rfiq.offsetHeight + 6
                })
                rfiAnswersDivsRef.current.forEach((rfia: HTMLElement, i: number) => {
                    injectHeight += rfia.offsetHeight + 6
                })
            }
        }

        if (hasInfo === 'info') {
            if (infoOpen === 'closed') {
                injectHeight += 40;
            } else {
                injectHeight += 54;
                infoBriefsDivsRef.current.forEach((info: HTMLElement, i: number) => {
                    injectHeight += info.offsetHeight + 6
                })
            }
        }

        if (hasTTL === 'ttl') {
            injectHeight += 40;
        }

        if (isCOAEditing === 'coa') {
            injectHeight += 51
        }

        if (isRFIEditing === 'rfi') {
            injectHeight += 51
        }

        if (isInfoEditing === 'info') {
            injectHeight += 51
        }

        injectHeight += 66;

        setNodeHeight(injectHeight + 'px')
    }

    /*
    const handleChange = async (selectedOption: ISelectedOption | null, actionMeta: ActionMeta<ISelectedOption>) => {
        setSelectedOption(selectedOption)
    }

    const options: ISelectedOption[] = [
        {label: '1', value: '1'},
        {label: '2', value: '2'},
        {label: '3', value: '3'},
        {label: '4', value: '4'},
        {label: '5', value: '5'},
        {label: '6', value: '6'},
        {label: '7', value: '7'},
        {label: '8', value: '8'},
    ];
    */

    const [{ isOver, isOverCurrent }, drop] = useDrop(
        () => ({
          accept: [ItemTypes.COA, ItemTypes.RFI, ItemTypes.INFO, ItemTypes.TTL],
          drop(_item: IDropItem, monitor) {
            const didDrop = monitor.didDrop()
            if (didDrop && !greedy) {
              return
            }

            switch(_item.name) { 
                case 'coa': { 
                    let hasCoa: boolean = false;
                    let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));

                    newNodes.forEach((item) => {
                        if (id.toString() === item.id) {
                            if (item.coas.length === 0) {
                                let newCOA: ICOA = new COA({})
                                newCOA.displayText = ''
                                newCOA.nextNodeId = ''
                                newCOA.id = item.coas.length + 1;
                                item.coas.push(newCOA)
                            } else {
                                hasCoa = true;
                            }
                        }
                    })

                    if (!hasCoa) {
                        setInjectComponents(injectComponents.map((inject: IInject) => {
                            if (inject.id === injectItem.id) {
                                return { ...inject, nodes: newNodes };
                            } else {
                                return inject;
                            }
                        }));

                        setInjectItem({
                            ...injectItem,
                            nodes: newNodes
                        });
                    }
                   break; 
                } 
                case 'rfi': { 
                    let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));

                    newNodes.forEach((item) => {
                        if (id.toString() === item.id) {
                            let newRFI: IRFI = new RFI();
                            newRFI.displayText = ''
                            newRFI.nextNodeId = ''
                            let rc = new RoleContent();
                            rc.role = "All";
                            rc.displayText = ""
                            newRFI.roleContent = [rc];
                            newRFI.id = item.rfis.length + 1;
                            newRFI.isNew = true;
                            item.rfiOpen = true;
                            item.rfis.push(newRFI)
                        }
                    })

                    setInjectComponents(injectComponents.map((inject: IInject) => {
                        if (inject.id === injectItem.id) {
                            return { ...inject, nodes: newNodes };
                        } else {
                            return inject;
                        }
                      }));

                    setInjectItem({
                        ...injectItem,
                        nodes: newNodes
                    });
                    
                   break;  
                }
                case 'info': { 
                     let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
                    
                     let hasBrief: boolean = false

                     newNodes.forEach((item) => {
                         if (id.toString() === item.id) {
                            if (item.informationBriefs.length === 0) {
                                let newInfo: IRoleContent = new RoleContent()
                                newInfo.displayText = ''
                                newInfo.role = '';
                                item.informationBriefs.push(newInfo)
                                item.infoOpen = true;
                            } else {
                                hasBrief = true;
                            }
                         }
                     })

                    if (!hasBrief) {
                        setInjectComponents(injectComponents.map((inject: IInject) => {
                            if (inject.id === injectItem.id) {
                                return { ...inject, nodes: newNodes };
                            } else {
                                return inject;
                            }
                        }));
    
                        setInjectItem({
                            ...injectItem,
                            nodes: newNodes
                        });
                    }
                    break;  
                 }
                 case 'ttl': { 
                    let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));

                    newNodes.forEach((item) => {
                        if (id.toString() === item.id) {
                            if (item.timeToLive !== null) {
                                item.timeToLive.id = 1
                            } else {
                                item.timeToLive = new TimeToLive()
                                item.timeToLive.id = 1
                            }
                        }
                    })

                    setInjectComponents(injectComponents.map((inject: IInject) => {
                       if (inject.id === injectItem.id) {
                           return { ...inject, nodes: newNodes };
                       } else {
                           return inject;
                       }
                     }));

                    setInjectItem({
                        ...injectItem,
                        nodes: newNodes
                    });
                   break;  
                } 
                default: { 
                   break; 
                } 
             }
          },
          collect: (monitor) => ({
            isOver: monitor.isOver(),
            isOverCurrent: monitor.isOver({ shallow: true }),
            canDrop: monitor.canDrop(),
          }),
        }),
        [greedy, injectItem]
      )

    const moveVote = useCallback((dragIndex: number, hoverIndex: number) => {
        let newNodes: IInjectNode[] = JSON.parse(JSON.stringify(injectItem.nodes));
    
        newNodes.forEach((item) => {
            if (id.toString() === item.id) {
                let injItem = item.coas.splice(dragIndex, 1);
                item.coas.splice(hoverIndex, 0, injItem[0]);
            }
        })

        setInjectItem({
            ...injectItem,
            nodes: newNodes
        });

        setInjectComponents(injectComponents.map((inject: IInject) => {
            if (inject.id === injectItem.id) {
                return { ...inject, nodes: newNodes };
            } else {
                return inject;
            }
          }));

    }, [injectItem, setInjectItem, setInjectComponents, injectComponents, id]) // eslint-disable-line react-hooks/exhaustive-deps

      const renderCOAVote = 
        (vote: { id: number; displayText: string; nextNodeId: string, x: number, y: number, isNew: boolean, v: number }, coaOpen: string, index: number) => {
          return (
            <Vote
              index={index}
              key={index}
              id={vote.id}
              coa={vote}
              nodeId={id}
              turn={turn}
              text={vote.displayText}
              moveVote={moveVote}
              injectItem={injectItem}
              setInjectItem={setInjectItem}
              isCOAEditing={isCOAEditing}
              isRFIEditing={isRFIEditing}
              isInfoEditing={isInfoEditing}
              setInjectComponents={setInjectComponents}
              injectComponents={injectComponents}
              voteType="coa"
              onChangeSave={onChangeSave}
              coaOpen={coaOpen}
              setIsCOADragging={setIsCOADragging}
              isCOADragging={isCOADragging}
              nodeHeight={nodeHeight}
              setCoaClicked={setCoaClicked}
              coaClicked={coaClicked}
              saveScenario={saveScenario}
              onFocus={onFocus}
              onBlur={onBlur}
            />
          )
        }

        const renderRFIVote = 
        (rfi: IRFI, index: number) => {
          return (
            <RFIVote
              index={index}
              key={index}
              nodeId={id}
              rfi={rfi}
              moveVote={moveVote}
              injectItem={injectItem}
              setInjectItem={setInjectItem}
              isRFIEditing={isRFIEditing}
              setInjectComponents={setInjectComponents}
              injectComponents={injectComponents}
              selectedScenario={selectedScenario}
              rfiOpen={rfiOpen}
              onChangeSave={onChangeSave}
              onFocus={onFocus}
              onBlur={onBlur}
            />
          )
        }

        const renderInfoVote = 
        (vote: { id: number; text: string; displayText: string; nextNodeId: string, x: number, y: number, isNew: boolean, v: number }, coaOpen: string, index: number) => {
          return (
            <Vote
              index={index}
              key={index}
              id={vote.id}
              coa={vote}
              nodeId={id}
              turn={turn}
              text={vote.displayText}
              moveVote={moveVote}
              injectItem={injectItem}
              setInjectItem={setInjectItem}
              isCOAEditing={isCOAEditing}
              isRFIEditing={isRFIEditing}
              isInfoEditing={isInfoEditing}
              setInjectComponents={setInjectComponents}
              injectComponents={injectComponents}
              voteType="info"
              onChangeSave={onChangeSave}
              coaOpen={coaOpen}
              setIsCOADragging={setIsCOADragging}
              isCOADragging={isCOADragging}
              nodeHeight={nodeHeight}
              setCoaClicked={setCoaClicked}
              coaClicked={coaClicked}
              saveScenario={saveScenario}
              onFocus={onFocus}
              onBlur={onBlur}
            />
          )
        }

        if (isOverCurrent || (isOver && greedy)) {
            if (nodeDiv !== undefined && nodeDiv !== null) {
                nodeDiv!.style.border = '2px solid #3F83FC';
            }
        } else {
            if (nodeDiv !== undefined && nodeDiv !== null) {
                nodeDiv.style.border = 'none';
            }
        }
    
    return (
      <div ref={mergeRefs(ref, drop)} data-testid={`inject`} className={`node ${node.coas.length === 0 ? 'end-node' : ''}`} data-id={id} data-turn={turn} key={index} style={{ 'height': nodeHeight, 'zIndex': (300-parseInt(id)) }}>
        { node.turn !== 1 &&
        <div className="node-dot1" style={{ visibility: isConnected ? 'hidden' : 'visible' }}></div>
        }
        <div className="node-content-lvl-2">
            {injectItem.nodes.map((item: IInjectNode, i: number) => {
                if (item.id === id.toString()) {
                    return (
                        <div key={i}>
                            <div className="node-content-title">{item.name}</div>
                            <div className="node-content-subtitle">Turn {item.turn}</div>
                        </div>
                    )
                } else {
                    return <div key={i}></div>
                }
            })}
            <div className="node-squares">
            {injectItem.nodes.map((node: IInjectNode, i: number) => {
                if (node.id === id.toString()) {
                 return (<div key={i}>
                    {node.coas.length > 0 ? <div className="node-square-coa"></div> : <></>}
                    {node.rfis.length > 0 ? <div className="node-square-rfi"></div> : <></>}
                    {node.informationBriefs.length > 0 ? <div className="node-square-info"></div> : <></>}
                    {node.timeToLive !== null ? <div className="node-square-ttl"></div> : <></>}
                    </div>)
                } else {
                    return (<div key={i}></div>)
                }
            })}
            </div>
        </div>
        <div className="node-content1">
            <div className="node-main">
                <div className="node-exclaim">
                    <img src="img/inject-exclaim.svg" alt="" className="node-exclaim-svg" />
                </div>
                <div className="node-text">
                    {injectItem.nodes.map((item: IInjectNode, i: number) => {
                        if (item.id === id.toString()) {
                            return (<input className="node-title" type="text" value={item.name} onChange={onChangeName} onKeyDown={nameKeyDown} key={i} data-id={item.id} onFocus={onFocus} onBlur={onBlur}/>)
                        } else {
                            return <div key={i}></div>
                        }
                    })}
                    
                    <div className="node-detail">
                        { node.coas.length === 0 ? 'Reaching this node during play ends the inject.' : `Starts Turn ${node.turn}`}
                    </div>
                </div>
            </div>
          <img src="img/node-ellipsis.svg" className="inject-ellipsis" onClick={clickNodeMenu} alt="ellipsis" />
          <div className={`node-menu ${showNodeMenu}`} id={`nodemenu${id}`}>
            <div className="menu-title">Choose an option</div>
            <img className="gray-ellipsis" src="img/gray-ellipsis.svg" onClick={clickNodeMenu} alt="ellipsis" />
            { id !== '1' ? <div className="menu-item" onClick={deleteNode}>Delete this Inject Node</div> : <></> }
            { node.coas.length > 0 ? <div className="menu-item" onClick={deleteCOA}>Delete COA Module</div> : <></> }
            { node.timeToLive !== null ? <div className="menu-item" onClick={deleteTTL}>Delete No Action Taken</div> : <></> }
            { node.rfis.length > 0 ? <div className="menu-item" onClick={deleteRFI}>Delete RFI Module</div> : <></> }
            { node.informationBriefs.length > 0 ? <div className="menu-item" onClick={deleteInfo}>Delete Information Brief</div> : <></> }
          </div>
          <div className={`edit-section`}>
            <div className={`description ${descOpen}`}>
                <div className="description-header">
                    <div className="description-page">
                        <img src="img/page.svg" className="description-page-svg" alt="icon" />
                    </div>
                    <div className="description-title">Description</div>
                    <div className="open-close-section" onClick={clickDescOpen}>
                        <img src="img/chevron-right-grey.svg" className={`chevron-right-grey ${rotateDescChevron}`} alt="arrow" />
                    </div>
                </div>
                <div className={`description-edit ${descOpen}`}  style={{ 'height': descHeight, 'top': descTop }}>
                    <ContentEditable
                        className="description-textarea"
                        data-placeholder="A Node"
                        data-id={node.id}
                        ref={contentEditableRef}
                        html={node.description} // innerHTML of the editable div
                        disabled={false}       // use true to disable editing
                        onChange={onChangeDescText} // handle innerHTML change
                        onFocus={onFocus}
                        onBlur={onBlur}
                    />
                </div>
            </div>
            <div 
                className={`coa-inject ${hasCoa}`} 
                style={{ 'height': coaHeight }}
            >
                <div className="coa-header">
                    <div className="description-page">
                        <img src="img/branch.svg" alt="" className="description-page-svg" />
                    </div>
                    <div className="description-title">Course Of Action</div>
                    <div className={`coa-edit ${isCOAEditing} ${node.coaOpen ? '' : 'hide-edit'}`} onClick={editCoa}>
                        <img src="img/edit.svg" alt="" className="edit-svg" />
                    </div>
                    <img src="img/chevron-right-grey.svg" alt=""  className={`chevron-right-grey ${rotateCOAChevron}`} onClick={clickCOAOpen}></img>
                </div>
                <div className={`coa-voting ${isCOAEditing} ${coaOpen}`} style={{ 'top': coaTop }}>
                    {node.coas.map((vote: ICOA, i: number) => renderCOAVote(vote, coaOpen, i))}
                </div>
                <div className={`coa-voting-btns ${showCoaEditBtns}`}>
                    <button className="scenario-btn add-option-btn" onClick={addCOAOption}>Add Option</button>
                    <button className="scenario-btn done-btn" onClick={editCoa}>Done</button>
                </div>
            </div>

            <div className={`node-ttl ${hasTTL}`} style={{ 'marginTop': ttlMarginTop }}>
                <div className="info-header">
                    <div className="ttl-node-icon">
                        <img src="img/ttl.svg" alt="" className="ttl-node-svg" />
                    </div>
                    <div className="info-title">No Action Taken</div>
                    { node.timeToLive !== null ? <TTLDots srcNodeId={id} setInjectItem={setInjectItem} injectItem={injectItem} injectComponents={injectComponents} setInjectComponents={setInjectComponents} turn={turn} ttl={node.timeToLive!} saveScenario={saveScenario} setIsCOADragging={setIsCOADragging} coaHeight={coaHeight} nodeHeight={nodeHeight} coaClicked={coaClicked} setCoaClicked={setCoaClicked} isCOADragging={isCOADragging} /> : <></> }
                </div>
            </div>

            <div className={`rfi-inject ${hasRFI}`} style={{ 'height': rfiHeight }}>
                <div className="rfi-header">
                    <div className="rfi-page">
                        <img src="img/rfi.svg" alt="" className="rfi-page-svg" />
                    </div>
                    <div className="rfi-title">Request For Information</div>
                    <div className={`rfi-edit ${isRFIEditing}  ${node.rfiOpen ? '' : 'hide-edit'}`} onClick={editRFI}>
                        <img src="img/edit.svg" alt="" className="edit-svg" />
                    </div>
                    <img src="img/chevron-right-grey.svg" alt="" className={`chevron-right-grey ${rotateRFIChevron}`} onClick={clickRFIOpen}></img>
                </div>
                
                <div className={`rfi-voting ${isRFIEditing} ${rfiOpen}`} style={{ 'top': rfiTop }}>
                    {/* Commenting out since this it not yet implemented.
                    <div className="rfi-participants">
                        <div className="rfi-participants-title">Max Participant Requests Allowed</div>
                        <Select
                            value={selectedOption}
                            components={{ DropdownIndicator: CustomDropdownIndicator }}
                            onChange={handleChange}
                            options={options}
                            styles={dropdownStyles}
                            className={'rfi-participants-styles'}
                        />
                    </div>
                    */}
                    {node.rfis.map((vote: IRFI, i: number) => renderRFIVote(vote, i))}
                </div>
                <div className={`rfi-voting-btns ${showRFIEditBtns}`}>
                    <button className="scenario-btn delete-btn" onClick={deleteRFI}>Delete Module</button>
                    <button className="scenario-btn add-option-btn" onClick={addRFIOption}>Add Option</button>
                    <button className="scenario-btn done-btn" onClick={editRFI}>Done</button>
                </div>
            </div>

            <div className={`info-inject ${hasInfo}`}  style={{ 'height': infoHeight }}>
                <div className="info-header">
                    <div className="info-page">
                        <img src="img/info.svg" alt="" className="info-page-svg" />
                    </div>
                    <div className="info-title">Information Briefs</div>
                    <img src="img/chevron-right-grey.svg" alt="" className={`chevron-right-grey ${rotateInfoChevron}`} onClick={clickInfoOpen}></img>
                </div>
                <div className={`info-voting ${isInfoEditing} ${infoOpen}`} style={{ 'top': infoTop }}>
                    {node.informationBriefs.map((vote: any, i: number) => renderInfoVote(vote, '', i))}
                </div>
                <div className={`info-voting-btns ${showInfoEditBtns}`}>
                    <button className="scenario-btn delete-btn" onClick={deleteInfo}>Delete Module</button>
                    <button className="scenario-btn add-option-btn" onClick={addInfoOption}>Add Option</button>
                    <button className="scenario-btn done-btn" onClick={editInfoDone}>Done</button>
                </div>
            </div>
          </div>
        </div>
      </div> 
    )
}

/*
type OptionType = {
    value: string;
    label: string;
};

const dropdownStyles: StylesConfig<OptionType, false> = {
    option: (provided, { isFocused, isSelected } : { isFocused: boolean, isSelected: boolean }) => ({
        ...provided,
        backgroundColor: isFocused ? "#393939" : "#191B22",
        fontSize: 13
    }),
    singleValue: (provided) => ({
        ...provided,
        padding: 0,
        color: '#AAADBC',
        backgroundColor: "#191B22",
        width: 120,
        fontSize: 13
    }),
    container:  (provided) => ({
        ...provided,
        backgroundColor: "#191B22",
        border: "none",
        borderBottom: "1px solid #383C4D",
        width: 120,
        height: 24
    }),
    control:  (provided) => ({
        ...provided,
        backgroundColor: "#191B22",
        color: "#AAADBC",
        borderRadius: 0,
        border: "none",
        width: 120,
        height: 20,
        minHeight: 24
    }),
    placeholder:  (provided) => ({
        ...provided,
        color: "#AAADBC",
        fontSize: 13
    }),
    indicatorSeparator:  (provided) => ({
        ...provided,
        display: "none"
    }),
    menu:  (provided) => ({
        ...provided,
        width: 120,
        color: '#AAADBC',
        backgroundColor: "#191B22",
        top: 20,
        zIndex: 1400
    }),
    menuList:  (provided) => ({
        ...provided,
        color: '#AAADBC',
        backgroundColor: "#191B22",
        paddingTop: 0,
        paddingBottom: 0,
        zIndex: 140
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#191B22',
        padding: 0,
        paddingRight: 8,
        height: 24
    }),
    input:  (provided) => ({
        ...provided,
        height: 24,
        marginTop: -6
    })
}
*/

export default Node;